/* global axios */
import ApiClient from './ApiClient';

class ZapiInstancesAPI extends ApiClient {
  constructor() {
    super('zapi/instances', { accountScoped: true });
  }

  // Live status + QR/pairing challenge. Hits Z-API on every call, so poll it, don't hammer it.
  status(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Billable: converts the trial into a paid subscription.
  subscribe(id) {
    return axios.post(`${this.url}/${id}/subscribe`);
  }

  // The only way to stop Z-API billing. Disconnecting the device does not cancel anything.
  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  // ApiClient#delete sends no body, and removing the inbox must be able to cancel the
  // subscription in the same call — otherwise a subscribed instance goes on being billed with
  // nothing left in the product pointing at it.
  remove(id, { cancelSubscription = false } = {}) {
    return axios.delete(`${this.url}/${id}`, {
      params: { cancel_subscription: cancelSubscription },
    });
  }

  restart(id) {
    return axios.post(`${this.url}/${id}/restart`);
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }

  phoneCode(id, phone) {
    return axios.post(`${this.url}/${id}/phone_code`, { phone });
  }

  configureWebhooks(id) {
    return axios.post(`${this.url}/${id}/configure_webhooks`);
  }

  // Agent-level: is a Z-API transport paired with this Cloud inbox? Drives the reply-box selector.
  transportStatus(inboxId) {
    return axios.get(`${this.url}/transport_status`, {
      params: { inbox_id: inboxId },
    });
  }
}

export default new ZapiInstancesAPI();
